import React from 'react';
import {DatePicker} from 'material-ui-pickers';
import Grid from '@material-ui/core/Grid';
import useStyles from './styles';

const DateIntervalPicker = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  disablePast,
  disableFuture,
  minDate,
  maxDate
}) => {

  const classes = useStyles();

  return (
    <Grid item xs={12} className={classes.picker}>
      <Grid container justify="space-evenly">
        <Grid item xs={12} sm={4}>
          <DatePicker
            name="startDate"
            label="Início"
            value={startDate}
            onChange={setStartDate}
            format={"DD/MM/YYYY"}
            className={classes.picker}
            {...{disableFuture, maxDate}}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <DatePicker
            name="endDate"
            label="Fim"
            value={endDate}
            onChange={setEndDate}
            format={"DD/MM/YYYY"}
            className={classes.picker}
            {...{disablePast, minDate}}
          />
        </Grid>
      </Grid>
    </Grid>
  )
};

export default DateIntervalPicker;
